module.exports = __webpack_public_path__ + "static/media/izlozba (5).971a97da.jpg";